var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Game-Development tools")]),_c('div',{staticStyle:{"margin-bottom":"30px"}},[_vm._v(" Here are some tools for game development I've worked on. ")]),_c('ProjectsList',{attrs:{"projects":_vm.projects}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }